import React from 'react';
import banner from '../assets/DSF-Nomex-Comfort-EcoFoce-BlueGarmentFemale-v2.jpg';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme, styled } from '@mui/material/styles';
// import {useInView} from 'react-intersection-observer';


const BannerContainer = styled('div')(({ theme, isMobile }) => ({
    position: 'relative',
    top: isMobile ? '2px' : '0px',
    width: '100%',
    overflow: 'hidden',
    height:'100%',
}));

const BannerImage = styled('img')(({ isMobile }) => ({
    width: '100%',
    height: isMobile ? '400px' : '550px',
    objectFit: 'cover'
}));

const BannerText = styled('div')({
    position: 'absolute',
    top: '73%',
    color: 'white',
    textAlign: 'left',
    backgroundColor: 'rgba(0, 0, 0, 0.26)', // Optional: Adds a semi-transparent background to the text
    padding: '10px',
    lineHeight: '0.5',
    height: '125px',
    width: '100%',

});

const BannerTextContent = styled('div')({
    padding: '20px',
    lineHeight: '0.7',
    marginBottom: '0px',
    
});

const BannerHeader = styled('h1')({
    fontSize: '3.5rem', // Increase the size of the header
    margin: '0',
    fontFamily: 'DiodrumSemibold',
});


const Banner = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <BannerContainer isMobile={isMobile}>
            <BannerImage src={banner} alt="Banner Image" isMobile={isMobile} />
            {/* <BannerText>
               <BannerTextContent>
                    <p style={{fontFamily:'DiodrumRegular',fontSize:'16px'}}>Nomex Comfort with </p>
                    <BannerHeader>EcoForce Technology</BannerHeader>
                </BannerTextContent>
            </BannerText> */}
        </BannerContainer>
    );
}

export default Banner;